"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[126],{

/***/ 50126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75713);
/* harmony import */ var _data_slider_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34755);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);




var contactHref = '/contatti?utm_source_button=carplanner-slider';

var SliderContainer = function SliderContainer() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .SliderComponent */ .Pi, {
    title: _data_slider_json__WEBPACK_IMPORTED_MODULE_2__/* .title */ .TN,
    image: _data_slider_json__WEBPACK_IMPORTED_MODULE_2__/* .image */ .BH,
    subtitle: _data_slider_json__WEBPACK_IMPORTED_MODULE_2__/* .subtitle */ .Oc,
    boxes: _data_slider_json__WEBPACK_IMPORTED_MODULE_2__/* .boxes */ .qk,
    contactAction: _data_slider_json__WEBPACK_IMPORTED_MODULE_2__/* .contact.action */ .PX.a,
    contactHref: contactHref
  });
};

/* harmony default export */ __webpack_exports__["default"] = (SliderContainer);

/***/ })

}]);